import React, {useEffect, useState, useRef} from "react";
import styled from "styled-components";

import iconSearch from "assets/icons/icon_search_blue.svg";
import iconClose from "assets/icons/icon_close_thick_black.svg";
import iconCheck from "assets/icons/icon_check_blue.svg";
import iconDrop from "assets/icons/icon_drop_black.svg";
import Input from "components/ui/input/Text";
import Popup from "../Popup";
import Button from "../Button";

export const Select = ({title, options, prefix, suffix, isIcon, isBlock, isSearch, isSubmit, onChange, ...props}) => {
	const self = useRef();
	const popupRef = useRef();
	const [value, setValue] = useState(props.value);
	const [visible, setVisible] = useState(false);
	const [search, setSearch] = useState();

	useEffect(() => {
		return () => {
			setVisible(false);
		};
	}, []);

	useEffect(() => {
		setValue(props.value);
	}, [props.value]);

	const eventHandler = {
		open : () => {
			setSearch();
			setVisible(true);
		},
		close : () => {
			popupRef.current.close();
		},
		submit : () => {
			setVisible(false);
			if(onChange)
				onChange(props.name, value);
		},
		render : (container) => {
			const middle = container.querySelector(".middle");
			if(middle) {
				const li = middle.querySelector("li.focus");
				if(li) {
					const half = middle.offsetHeight / 2;
					let offsetTop = li.getBoundingClientRect().top - middle.getBoundingClientRect().top;
					offsetTop = offsetTop - half + (li.offsetHeight / 2);
					if(offsetTop < 0) offsetTop = 0;
					middle.scrollTop = offsetTop;
				}
			}
			/*
				const li = container.querySelector(".middle li.focus");
				if(li) li.scrollIntoView({block: "center"});
		 	 */
		},
		changeSearch : (event) => {
			const value = event.currentTarget.value;
			if(search != value);
				setSearch(value);
		},
		changeValue : (event) => {
			const value = event.currentTarget.getAttribute("data-value");
			setValue(value);
			if(!isSubmit) {
				setVisible(false);
				if(onChange)
					onChange(props.name, value);
			}
		}
	};

	const render = () => {
		const getOptionList = () => {
			let li = (options || []).filter(item => {
				return (search) ? (item.label.indexOf(search) > -1) : true;
			}).map(item => {
				return (
					<li key={item.value} className={(item.value == value) ? "focus" : ""} data-value={item.value} onClick={eventHandler.changeValue}>
						{(item.image) ? <img src={item.image} /> : null}
						<span dangerouslySetInnerHTML={{__html : item.label}}></span>
					</li>
				);
			});
			if(!li.length) {
				li = (<li className="empty">검색 결과가 없습니다.</li>);
			}
			return <ul>{li}</ul>;
		};

		const getClassName = () => {
			const nameList = [];
			if(isBlock) nameList.push("block");
			if(isIcon) nameList.push("icon");
			return nameList.join(" ");
		};

		return (
			<Wrapper className={getClassName()} {...props}>
				<div onClick={eventHandler.open}>
					{props.children}
				</div>
				<StyledPopup preventDefault={false} ref={popupRef} open={visible} onClose={setVisible} onRender={eventHandler.render}>
					<div className="top">
						<h3 dangerouslySetInnerHTML={{__html : title}} />
						<a onClick={eventHandler.close}></a>
					</div>
					<div className="middle">
						<div>
							{(prefix) ? prefix : null}
							{(isSearch) ? <Input placeholder="강사 이름으로 검색" onInput={eventHandler.changeSearch} /> : null}
							{getOptionList()}
							{(suffix) ? suffix : null}
						</div>
					</div>
					{
						(isSubmit) ?
							<div className="bottom">
								<Button color="blue" onClick={eventHandler.submit}>선택</Button>
							</div> : null
					}
				</StyledPopup>
			</Wrapper>
		);
	};

	return render();
};

const Wrapper = styled.div`
&							{display:inline-flex}
& + &						{margin-left:0.75em}
&.icon > div:after			{content:""; height:1em; padding-right:1em; background:url(${iconDrop}) no-repeat center right / 0.65em}
&.block						{display:block}
/*
&.block	> div				{display:flex; align-items:center; justify-content:center}
*/

`;

const StyledPopup = styled(Popup)`
&							{font-size:1rem}
.top						{position:relative}
.top a						{position:absolute; right:0; top:0; width:24px; height:24px; background:url(${iconClose}) no-repeat center center / 0.85em}

.middle 					{margin:0 -24px; max-height:50vh; font-weight:600; overflow-y:auto; -webkit-overflow-scrolling:touch}
.middle > div				{padding:0 24px}
.middle input				{margin:0 -5px; padding-left:3em; background:#f8f9fd url(${iconSearch}) no-repeat left 18px center / 1em; border-radius:var(--lineHeight); border:none}
.middle ul					{}
.middle ul li				{padding:6px 0}
.middle ul li + li			{margin-top:4px}
.middle ul li.empty			{color:var(--gray)}
.middle ul li img			{display:inline-block; vertical-align:middle; margin-right:10px; width:32px; height:32px; border-radius:100%; object-fit:cover}
.middle ul li.focus			{background: url(${iconCheck}) no-repeat right center / 1em; font-weight:bold; color:var(--blue)}
.middle input + ul			{margin-top:10px}		
`;

export default Select;